import { render } from "./IndexOnboardPage.vue?vue&type=template&id=edbe3696"
import script from "./IndexOnboardPage.vue?vue&type=script&lang=js"
export * from "./IndexOnboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__